<template functional>
    <div class="v2_info-popup__body">
        <ul class="list-style-disc pl-3">
            <li>
                Create the profile of a desired job (your Ideal Career Opportunity) by defining the terms you require.
            </li>
            <li>
                Review job opportunities that match the terms of your ICOs.
            </li>
            <li>
                Manage communication between you and the job offeror, remaining
                anonymous throughout.
            </li>
            <li>
                We actively curate our platform to ensure accurate and credible job
                postings.
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'ExchangeInfoPopup',
};
</script>

<style scoped></style>
